import SignaturePad from "signature_pad";
import "./signature-pad.css";

function resizeCanvas(canvas, signaturePad) {
  const ratio =  Math.max(window.devicePixelRatio || 1, 1);
  // fixate the size of the canvas so it doesn't grow indefinitely if
  const canvasWidth = canvas.offsetWidth;
  const canvasHeight = canvas.offsetHeight;
  canvas.style.flexGrow = null;
  canvas.style.width = `${canvasWidth}px`;
  canvas.style.height = `${canvasHeight}px`;
  canvas.width = canvas.offsetWidth * ratio;
  canvas.height = canvas.offsetHeight * ratio;
  canvas.getContext("2d").scale(ratio, ratio);
  signaturePad.clear(); // otherwise isEmpty() might return incorrect value
}

function initializeSignaturePad(scope = null) {
   if (scope === null || scope === undefined) {
     scope = document;
   }
   const canvases = scope.querySelectorAll(":scope canvas.signature-pad");
   for (let i = 0, len = canvases.length; i < len; ++i) {
     const canvas  = canvases[i];
     let signaturePadOptions  = {};
     const signaturePadOptionsString = canvas.dataset?.signaturePadOptions;
     const padFormFieldName = canvas.dataset?.name;
     const padValue = canvas.dataset?.value;
     if(typeof signaturePadOptionsString === "string" && signaturePadOptionsString !== "") {
       signaturePadOptions = JSON.parse(signaturePadOptionsString);
     }

     const pad = new SignaturePad(canvas, signaturePadOptions);
     if(typeof padValue!== "undefined" && padValue !== "") {
       pad.fromDataURL(padValue).then( /* do nothing but the IDE complains if you ignore the promise */ );
     }
     window.addEventListener("resize", () => resizeCanvas(canvas, pad));
     resizeCanvas(canvas, pad);
     if(typeof padFormFieldName === "string" && padFormFieldName!== "") {
       const formField = document.createElement("input");
       formField.type = "hidden";
       formField.name = padFormFieldName;
       formField.value = padValue;
       canvas.after(formField);
       pad.addEventListener("endStroke", () => {
         formField.value = pad.toDataURL();
       });

       // find reset button with same name
       const resetButton = scope.querySelector(":scope button[data-name='" + padFormFieldName + "']");
       if(resetButton) {
         resetButton.addEventListener("click", ()  => {
           pad.clear();
           formField.value = null;
         });
       }
     }
   }
}

export default initializeSignaturePad;
